import { Record } from 'immutable';

class Errors extends Record({'errorMessages': {}}) {

  addError(field, errorMessage) {
    let errorMessages = this.get('errorMessages');
    errorMessages[field] = errorMessage;
    return this.set('errorMessages', errorMessages);
  }

  getError(field) {
    return this.get('errorMessages')[field];
  }

  clear(field) {
    let errorMessages = this.get('errorMessages');
    delete errorMessages[field];
    return this.set('errorMessages', errorMessages);
  }

  clearAll() {
    return this.set('errorMessages', {});
  }

  hasErrors() {
    const errorMessages = this.get('errorMessages');
    return Object.keys(errorMessages).length > 0;
  }

  hasError(field) {
    const error = this.getError(field);
    return error !== undefined && error !== null;
  }

}

export default Errors;
